export const getCountries = state => {
    return state.countries;
};
